<article class="post">
  @if (dataList && dataList.length > 0) {
    <div class="row">
      @for (article of getDisplayArticles(); track article; let i = $index) {
        <div
          [class]="getColumnClass()">
          <div class="article-container">
            <div class="post-content">
              <!-- Article Title -->
              <h5>
                <a
                  class="from-journal article-title-link"
                  [routerLink]="['/journal', article.journalSlug || parentSlug, 'article', article.slug]"
                  [queryParams]="(article.ID || article.id) ? { id: (article.ID || article.id) } : {}"
                  [title]="article.title">
                  {{ article.title }}
                </a>
              </h5>
              <!-- Article Abstract -->
              @if (hasAbstract(article)) {
                <div
                  class="mb-1 abstract"
                  [innerHTML]="getFormattedAbstract(article.abstract!)">
                </div>
              }
              <!-- Authors -->
              @if (article.authors && article.authors.length > 0) {
                <div class="post-meta">
                  <span class="authors-list">
                    @for (author of article.authors; track author; let authorIndex = $index) {
                      <span>
                        <app-author-view [author]="author"></app-author-view>
                        @if (authorIndex < article.authors.length - 1) {
                          <span>,&nbsp;</span>
                        }
                      </span>
                    }
                  </span>
                </div>
              }
              <!-- Article Metadata -->
              <div class="post-meta">
                <div class="row">
                  <!-- DOI Section -->
                  @if (hasDoi(article)) {
                    <div class="col-md-12">
                      <div class="doi-container">
                        <span class="doi-label from-journal">
                          {{ 'DOI' | translate }} :
                        </span>
                        <a
                          class="doi-value"
                          [title]="'DOI' | translate"
                          [href]="getDoiUrl(article.doi!)"
                          style="cursor: pointer;">
                          {{ article.doi }}
                        </a>
                      </div>
                    </div>
                  }
                  <!-- Badges Section -->
                  <div class="col-md-12 text-right mt-1">
                    <div class="badges-container">
                      <!-- Section Badge -->
                      @if (article.section) {
                        <span
                          class="badge badge-custom badge-sm mr-2">
                          {{ '@' + article.section | translate }}
                        </span>
                      }
                      <!-- Language Badge -->
                      @if (article.localeText) {
                        <span
                          class="badge badge-custom badge-sm mr-2 text-uppercase">
                          {{ getLanguageCode(article.localeText) }}
                        </span>
                      }
                      <!-- Page Range Badge -->
                      @if (hasPageNumbers(article)) {
                        <span
                          class="badge badge-custom badge-sm mr-2">
                          {{ 'ARTICLE_LBL_SHORTCUT_PAGE' | translate }}. {{ getPageRange(article) }}
                        </span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Separator (except for last item) -->
            @if (!isLastItem(i)) {
              <hr class="article-separator">
            }
          </div>
        </div>
      }
    </div>
  }
</article>
